import React, { useState, useEffect } from 'react';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Icon from '@material-ui/core/Icon';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme=> ({
    Card: {       
        width: '225px',
    },    
    Link : {
        textDecoration: 'none',
        color: 'initial'
    },
    CardContent: {
        fontFamily: 'Roboto',
        padding: '5px 15px',
        minHeight: '190px',
        fontSize: '15px'       
    },
    ItemPrice: {
        fontWeight: '400', 
        fontSize: '21px', 
        lineHeight: '1.3',
        marginTop: theme.spacing(0.5),
        alignItems: 'center',
        display: 'flex',
        width: '100%',
        '& span' : {
            color: '#3483fa', fontSize: '14px', marginLeft: theme.spacing(1), fontWeight: '500'
        }
    },
    OldPrice: {
        fontWeight: '300', 
        fontSize: '14px', 
        color: theme.palette.text.secondary, 
        textDecoration: 'line-through',
        marginTop: theme.spacing(0.3),
    },
    SponsorConditionLabel: {
        background: theme.palette.sponsored.main,
        borderRadius: '3px',
        display: 'inline-block',
        color: '#fff',
        fontSize: '13px',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '1px 8px 1px 5px',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        marginTop: theme.spacing(.5)
    },
    ConditionLabel: {
        fontWeight: 300,
        fontSize: '13px',
        color: theme.palette.sponsored.main,
        marginTop: theme.spacing(.5)
    },
    AdTitle: { 
        display: 'flex', 
        flexWrap: 'wrap', 
        fontSize: '14px',
        color: theme.palette.text.secondary, 
        fontWeight: '400', 
        marginTop: theme.spacing(1),
        lineHeight: 1.4,
        maxHeight: '40px',
        overflow: 'hidden'
    },
    ExtraInfo: {
        fontSize: '13px', 
        fontWeight: '300', 
        marginTop: theme.spacing(0.8), 
        color: theme.palette.text.secondary
    },
    NameInAds: {
        fontWeight: '300', fontSize: '12px', color: theme.palette.text.secondary, marginTop: theme.spacing(0.4),        
        '& span' : {
            color: '#757575',
            fontWeight: '500'
        }
    }
}))

const formatter = new Intl.NumberFormat('es-AR');

export default function Anuncio(props) {
    const classes = useStyles(); 
    const [content, setContent] = useState(null)

    useEffect(()=> {
        if (props.content)            
            setContent(props.content)        
    }, [content])

    return content 
            ? (
                <Card className={classes.Card} variant={props.variant} >
                    
                    <CardActionArea href={`https://www.agroads.com.ar/detalle.asp?clasi=${content.id}`} target="_blank">
                    <img width="225px" src={content.picture} />
                            <CardContent className={classes.CardContent}>
                                
                                    <div className={classes.ItemPrice}>
                                        {content.currency} {content.finalPrice} 
                                        <span>{content.discount > 0 ? `${content.discount}% OFF` : null}</span>
                                    </div>
                                    {content.discount > 0
                                        ? <div className={classes.OldPrice}>{content.currency} {formatter.format(content.price)}</div>
                                        : null
                                    }
                                    {content.commercialCondition !== ''
                                        ? content.sponsored
                                            ? <div className={classes.SponsorConditionLabel}><Icon style={{ fontSize: '15px', marginTop: '-1px', display: 'inline-block', verticalAlign: 'middle' }}>access_time</Icon> {content.commercialCondition}</div>
                                            : <div className={classes.ConditionLabel}>{content.commercialCondition}</div>
                                        : null
                                    }
                                    <div className={classes.AdTitle}>{content.title}</div>
                                    <div className={classes.ExtraInfo}>{content.year ? content.year + ' - ' : null}{content.usage ? content.usage + ' hs - ' : null}{content.location ? content.location : null}</div>
                                    {
                                        content.nameInAds === 1
                                            ? <div className={classes.NameInAds}>por <span>{content.seller}</span></div>
                                            : null
                                    }            
                            </CardContent>
                    </CardActionArea>                    
                </Card >   
                )
            : null//skeleton    
}